export default __webpack_public_path__ + "static/media/stefan-oancea.c58804fc.png";